<template>
  <div class="wrap">
    <img class="backImg" src="../../assets/home.jpg" alt />
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang='less'>
.wrap {
}
.backImg {
  position: absolute;
  top: 35px;
  left: 0;
  width: 100%;
  height: 823px;
}
</style>